import { IDestroyOptions } from "@pixi/display";
import { PlayerModel } from "../../../../models/player/PlayerModel";
import { GameViewController } from "../../../../controllers/GameViewController";
import { ScaleUpCallableAnimationButton } from "../../../../../common/components/buttons/ScaleUpCallableAnimationButton";
import { GameModel } from "../../../../models/game/GameModel";
import { AudioManager } from "../../../../../../audio/AudioManager";
import { Sprite } from "@pixi/sprite";
import { BaseBoosterButton } from "./BaseBoosterButton";
import { GameUIResourcesPackage } from "../../../../../preloader/resources/GameUIResourcesPackage";

export class ShuffleBoosterButton extends BaseBoosterButton {
    public readonly shuffleButton: ScaleUpCallableAnimationButton;
    private readonly adButton: ScaleUpCallableAnimationButton;

    public constructor(
        private readonly playerModel: PlayerModel,
        private readonly gameModel: GameModel,
        private readonly gameViewController: GameViewController,
        private readonly audioManager: AudioManager,
        resources: GameUIResourcesPackage
    ) {
        super(resources);
        this.shuffleButton = new ScaleUpCallableAnimationButton({
            defaultTexture: resources.assets_game_button_substrate_purpure_png
        }, this.audioManager);
        const shuffleIcon = this.shuffleButton.addChild(new Sprite(resources.assets_game_button_icon_shuffle_png));
        shuffleIcon.position.set(25, 17);
        this.adButton = new ScaleUpCallableAnimationButton({
            defaultTexture: resources.assets_game_ad_play_btn_png
        }, audioManager);
        this.addChild(this.shuffleButton);
        this.addChild(this.adButton);
        this.adButton.visible = false;
        this.adButton.position.set(90, 90);
        this.shuffleButton.onUp.add(this.handleShuffleDeck, this);
        this.adButton.onUp.add(this.handleAdButtonUp, this);
        this.playerModel.onChanged.add(this.redrawShuffles, this);
        this.gameModel.onGameOver.add(this.handleGameOver, this);
        this.redrawShuffles();
    }

    private handleShuffleDeck(): void {
        this.gameViewController.shuffleDeck();
    }

    private handleAdButtonUp(): void {
        this.gameViewController.shuffleDeck();
    }

    private redrawShuffles(): void {
        if (this.playerModel.Shuffles == 0) {
            this.adButton.visible = true;
        } else {
            this.adButton.visible = false;
        }
    }

    private handleGameOver(isHaveShuffles: boolean): void {
        if (isHaveShuffles) {
            this.shuffleButton.playAnimation();
        }
        else {
            this.shuffleButton.stopAnimation();
        }
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.playerModel.onChanged.remove(this.redrawShuffles, this);
        this.shuffleButton.onUp.remove(this.handleShuffleDeck, this);
        this.adButton.onUp.remove(this.handleAdButtonUp, this);
        this.gameModel.onGameOver.remove(this.handleGameOver, this);
        super.destroy(options);
    }
}